/**
 * ============================================
 * App - Main Entry Component
 * ============================================
 *
 * 홈 페이지 (대시보드) 렌더링
 */

import HomePage from './pages/HomePage';

function App() {
  return <HomePage />;
}

export default App;
